import React, {Fragment} from 'react';
import {Skeleton, Stack} from '@mui/material';

import {MainHeader} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {StyledContainer} from './styles';
import {BookingLoadingStateProps} from './types';

export function BookingLoadingState({
	pageTitle,
	handleBack,
	loadingText,
	variant = 'spinner',
	showHeader = true,
	hideBackBtn,
}: BookingLoadingStateProps) {
	const {isMobile} = useMediaQueries();

	return (
		<Fragment>
			{showHeader ? (
				<MainHeader
					title={pageTitle}
					handleBack={handleBack}
					handleClose={handleBack}
					variant="subRoute"
					hideBackBtn={hideBackBtn}
				/>
			) : null}
			{variant === 'spinner' ? (
				<StyledContainer>
					<Loading text={loadingText} />
				</StyledContainer>
			) : (
				<Stack gap={2} sx={{width: '100%', alignItems: 'initial'}}>
					<Skeleton height={isMobile ? 85 : 80} sx={{transform: 'initial'}} />
					<Skeleton
						height={isMobile ? 24 : 50}
						width={isMobile ? '100%' : '70%'}
						sx={{transform: 'initial'}}
					/>
					<Skeleton
						height={isMobile ? 85 : 144}
						width={isMobile ? '100%' : '50%'}
						sx={{transform: 'initial'}}
					/>
				</Stack>
			)}
		</Fragment>
	);
}
